import { useTheme, type ThemePref } from "@/app/theme";
import { ToolIcon } from "@/app/toolIcons";
import { Segmented, type SegmentedOption } from "@/ui";

const OPTIONS: SegmentedOption<ThemePref>[] = [
  { value: "system", label: <ToolIcon name="monitor" />, title: "跟随系统" },
  { value: "light", label: <ToolIcon name="sun" />, title: "浅色" },
  { value: "dark", label: <ToolIcon name="moon" />, title: "深色" },
];

/** 顶栏的主题切换：跟随系统、浅色、深色，点了立即生效并记在浏览器里（决策 D200）。 */
export function ThemeSwitch() {
  const { pref, setPref } = useTheme();
  return <Segmented label="主题" options={OPTIONS} value={pref} onChange={setPref} />;
}
